import { render } from "./expenses-approval.vue?vue&type=template&id=61b05e3e"
import script from "./expenses-approval.vue?vue&type=script&lang=js"
export * from "./expenses-approval.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__